module.exports = __webpack_public_path__ + "img/zhaoshang_xianshang@2x.f2cda9b9.png";